import React, {useState, useEffect} from "react";
import { useForm, Controller, control, NavLink } from "react-hook-form";
import Select, { StylesConfig }  from "react-select";
import {Input, Button, Box, Stack, AppBar, styled, Toolbar,Typography, InputBase,Avatar } from "@mui/material";
import { theme, Badge, } from "@material-ui/core";
import  HomeOutlinedIcon  from "@mui/icons-material/HomeOutlined";
import chroma from 'chroma-js';


import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header.jsx";
//import sendDataToAPI from '../../methods/sendDataToAPIs.jsx';

import { DatePicker, Space } from 'antd';
import Contacts from "../../scenes/contacts/index.jsx";
//import itemNavLink from "./ItemNavLink.jsx";
import TableCMAA from "../form/TableCMAA.jsx";
import TableXDataGrid from "../form/TableXDataGrid.jsx";
import { ColorModeContext } from "../../theme.js";
import ImageFiller from "react-image-filler";
import CMMForm from "../form/CMMForm.jsx";
import FRMAXIOSEDIT from "../form/FRMAXIOSEDIT.jsx";
import PCEditModal from "../form/PCEditModal.jsx";
import FRMNewProject from "../form/FRMNewProject.jsx";
import FRMNewProjectTest from "../form/FRMNewProjectTest.jsx";
import FormProjectAddPic from "../form/FormProjectAddPic.jsx";

//import Modal from 'react-bootstrap/Modal'; FRMNewProjectTest

//import Axntd from "./axntd.jsx";

export default function FormProjects(props) {
 
    const handleEditProjectCategory=()=>{
     
    }

    const {
      register,
      control,
      handleSubmit,
      watch,
      formState: { errors },
    } = useForm()
    //
    const[tableColumns, setTableColums]=useState(
      [
        {'id': 1, 'title': 'ID', 'name': 'id'},
        {'id': 2, 'title': 'Project Category Name', 'name': 'first_name'},
        {'id': 3, 'title': 'Pic Intro', 'name': 'middle_name'},
        {'id': 4, 'title': 'Web Intro', 'name': 'last_name'},
        {'id': 5, 'title': 'Telephone', 'name': 'telephone'},
        {'id': 6, 'title': 'Email', 'name': 'email'},
        {'id': 7, 'title': 'Gender', 'name': 'gender'},
    ]
    )
    //
   
    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: "white" }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma(ColorModeContext.color)
        return {
          ...styles,
          backgroundColor: isDisabled
            ? undefined
            : isSelected
            ? data.color
            : isFocused
            ? color.alpha(0.1).css()
            : undefined,
          color: isDisabled
            ? "#ccc"
            : isSelected
            ? chroma.contrast(color, "white") > 2
              ? "white"
              : "black"
            : data.color,
          cursor: isDisabled ? "not-allowed" : "default",
    
          ":active": {
            ...styles[":active"],
            backgroundColor: !isDisabled
              ? isSelected
                ? data.color
                : color.alpha(0.3).css()
              : undefined
          }
        }
      },
      input: styles => ({ ...styles, ...dot() }),
      placeholder: styles => ({ ...styles, ...dot("#ccc") }),
      singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) })
    }
    
    //
    const dot = (color = 'transparent') => ({
      alignItems: 'center',
      display: 'flex',
    
      ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
      },
    });

    
    const customStyles = {
      option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        //backgroundColor: isFocused ? "#6BD5C0" : "#320B63",
      };
    }
  };
    //
    const [submitClicked, changeSubmitClicked]=useState(false);
    const [txtFullName, changeTxtFullName]=useState('');
    const [txtFullNameSimilar, changeTxtFullNameSimilar]=useState(' ');
    const [imgPath, setImgPath]=useState('../../../../../');
    //
    const [onOpenStatus, setOnOpenStatus]=useState(false);
    
    const OnOpenStatusToTrue=()=>{
      setOnOpenStatus(true);
      console.log("OUT");
    }
    //
     //
    const renderDetailsButton = (params) =>{
      return
      (
        <strong>
        
          <Button
          onClick={()=>{
            alert("")
          }}
          >
            EDIT
          </Button>
        </strong>
      )
    }
    //

    useEffect(()=>{
      console.log(" XYXY onOpenStatus=" + onOpenStatus)
    }, [onOpenStatus])
    
    //const tableXDataGridColumns =[
     const tableXDataGridColumns =[
        {
          field: 'id',
          headerName: 'ID',
          flex: 1,
          cellClassName: 'name-column--cell',
          type: 'number',
          align: 'left'
      },
      {
        field: 'service_category_name',
        headerName: 'Service Category Name',
        flex: 1,
        cellClassName: 'name-column--cell',
        type: 'string',
        align: 'center'
      },
      {
        field: 'project_category',
        headerName: 'Project Category Name',
        flex: 1,
        cellClassName: 'name-column--cell',
        type: 'string',
        align: 'center'
      },
    {
      field: 'pic_intro',
      headerName: 'Pic Intro',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
  },
  {
    field: 'intro_txt',
    headerName: 'Web Intro',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
  },
  /**
  {
  field: 'creation_date',
  headerName: 'Date Created',
  flex: 1,
  cellClassName: 'name-column--cell',
  type: 'string',
  align: 'left'
  },
  **/
      {
        field: 'img',
        headerName: 'IMAGE',
        flex: 3,
        cellClassName: 'name-column--cell',
        type: 'img',
        align: 'left',
        renderCell: (params)=>{
          return (
            <div>
              <img  src={"../../../../../static/media/" + params.value}
              sx={{
                height: "190px",
                width: "190px"
              }} 
              onClick={(e)=>{
                setOnOpenStatus(true);
                console.log("img QQQ =" + params.value);
                OnOpenStatusToTrue();
                console.log("IN onOpenStatus=" + onOpenStatus);
              }}
              />
            </div>
          )
        }
        },
        {
          field: '',
          headerName: 'Edit',
          flex: 1,
          cellClassName: 'name-column--cell',
          type: 'string',
          align: 'left',
          renderCell: ({row})=>{
            <Button>ABCDEFG</Button>
          }
          },   

     ]
    
    //
    const changeOnOpenStatusFromPCEditModal=(data)=>{
      setOnOpenStatus(data);
    }
    //
    const onChangeDate = (date, dateString) => {
  
      console.log("date=" + date);
      console.log("dateString=" + dateString);
      console.log(date, dateString);
      setPatientDOB(dateString);
      console.log("PatientDOB=" + patientDOB);
  };
    //
    const validateString=(stringValue, similarStringValue)=>{
      let validateString=false
      if(stringValue==="" || stringValue==similarStringValue){
        validateString=true
      }
    }

    function validateOnSubmit(){
          let validateOnSubmitStatus=false;
          validateString=(txtFullName, txtFullNameSimilar)
          
          return validateOnSubmitStatus
    }
    //
    
    /**
    let formData=[
      {'name': 'txtProjectCategoryName', 'value': ProjectCategoryName, 'type': 'string'}
    ]
    **/
    
    //
    const onSubmit = (data) => { 
      //alert("");
      //console.log(event.target[0].value)
      console.log(data['txtProjectCategoryName']);
      //console.log("formData0=" + formData[0]);
      return;
      //alert("form=" + form[0]);
      //inputProps
      changeSubmitClicked(true);
      let validateStatus=validateOnSubmit();
      console.log("data=" + data)
      console.log("dt__=" + JSON.stringify(data))
      console.log("validateStatus=" + validateStatus)
      if (validateStatus==true){
        console.log("error=" + true)
        return;
      }
      return;
      const jsonObj=data;
      const myobj={
            name: jsonObj['txtProjectCategoryName'],
            pic_intro: jsonObj['txtPicIntro'],
            intro_txt: jsonObj['txtWebIntro'],
            status: 'Active',
            service_category: jsonObj['txtServiceCategory'],
            /*
            *
            'service_category',
           'name',
           'pic_intro',
           'intro_txt',
           'status'
            */
            
      }
      const APIURL="/myapi/postPrimaryProjectCategory";
      const bodyJSON=JSON.stringify(data);
      const requestOptions ={
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify(myobj),
      };
     // return;
      try {
               console.log("bb=" + requestOptions);
               fetch(APIURL, requestOptions)
               .then( (response) =>  response.json())
               .then( (data) => console.log(data))
               .then( (data) => alert(data))
          }
     catch(err) {
     console.log(err.message);
       }
    }
     
    const insuranceCategoryValues=[
      { value: 'Select Insurance Category', label: 'Select Insurance Category' },
      { value: 'NHIF', label: 'NHIF' },
      { value: 'ABC', label: 'ABC' },
      //'Male', 'Female' placeholder="Select Insurance Category"
    ]
    
    
    const genderValues=[
      { value: 'Select Gender', label: 'Select Gender' },
      { value: 'Male', label: 'Male' },
      { value: 'Female', label: 'Female' },
      //'Male', 'Female' placeholder="Select Insurance Category"
    ]
    
    
    const onOptionChangeHandler = (event) => {
      console.log("User Selected Value - ", event.target.value);
    }
    
    const [patientGender, setPatientGender]=useState({label :'Select Gender', value:'Select Gender' });
    //console.log(watch("example")) // watch input value by passing the name of it

    const [patientDOB, setPatientDOB]=useState('');
    
    const findGender = (event) => {
      //console.log("e0=" + event[0].value);
      console.log("e=" + event);
      setPatientGender(event);
    }
    

    const [insuranceCategory, setInsuranceCategory]=useState(
      { value: 'Select Insurance Category', label: 'Select Insurance Category' }
      );
    //console.log(watch("example")) // watch input value by passing the name of it

    const findInsuranceCategory = (event) => {
      //console.log("e0=" + event[0].value);
      console.log("e=" + event);
      setInsuranceCategory(event);
    }

    const StyledBox= styled(Box)({
      marginLeft: "10px",
      marginRight: "10px",
      marginTop: "10px",
    })


    const StyledInput= styled(Input)({
      width: "100%",
      fontSize: "14px",
      //fontColor: "black",
      height: "95%",
      marginBottom: "2px",
      marginTop: "2px",
    })

    {/**
    const StyledInput= styled(Input)({
      width: "100%",
      fontSize: "14px",
      fontColor: "black",
      height: "95%",
      marginBottom: "2px",
      marginTop: "2px",
    })
  **/}
    
    const StyledSelect= styled(Select)({
      width: "100%",
      fontSize: "14px",
      fontColor: "white",
      height: "95%",
      marginBottom: "2px",
      marginTop: "2px",
    })

    const TXTRoundedDiv = styled("div")(({ theme }) => ({
      backgroundColor: "",
      border: '1px solid #6BD5C0',
      //borderColor: "#6BD5C0",
      /** 
       * #6BD5C0
       * #8868B0
       *#320B63
       #01579b
       #4527a0
       #311b92
      **/
      borderRadius: theme.shape.borderRadius,
      width: "100%",
      fontSize: "14px",
      marginBottom: "10px"
    }));
   
    {/**
    const TXTRoundedDiv = styled("div")(({ theme }) => ({
      backgroundColor: "grey",
      borderRadius: theme.shape.borderRadius,
      width: "100%",
      fontSize: "14px",
      marginBottom: "10px"
    }));
  **/}
   
    const node = document.querySelector("#app");

    const changeDate = (jsDate, dateString) => {
      // ...
    };
    
    const [ProjectCategoryRecordsUrl, setProjectCategoryRecordsUrl]=useState('/myapi/ProjectCategoryAndPicsView');
    //const [patientDOB,]
    const onChangeDOB = (date, dateString) => {
      console.log(date, dateString)
      setPatientDOB(dateString)
      console.log("pdob=" + patientDOB)
    };
    

    /***
    ***/
    /** **/
    const myBox=()=> {
      return <div className="box"> ABC </div>;
      {/**{showRecords ? <myBox /> : <PRFHooks/>}**/}
    }
    const tOPButtonOnClick = () =>{
       if(showForm==true){
        setShowForm(false)
        setTopButtonLabel('Show Records')
       }
       else{
        setShowForm(true)
        setTopButtonLabel('Show Form')
       }
    }
    const [showForm, setShowForm] = useState(true);
    
    const [ShowTableXDataGrid, setShowTableXDataGrid] = useState(false);
    //TableXDataGrid

    const [showFormEdit, setShowFormEdit] = useState(false);

    const [topButtonLabel, setTopButtonLabel]=useState('Show Records');
    

    const tOPButtonTOnClick = () =>{
      if(showFormT==true){
       setShowFormT(false)
       setShowTableXDataGrid(false)
       setTopButtonLabelT('Show Records')
      }
      else{
       setShowFormT(true)
       setShowTableXDataGrid(true)
       setTopButtonLabelT('Show Form')
      }
   }
    const [showFormT, setShowFormT] = useState(true);
    const [topButtonLabelT, setTopButtonLabelT]=useState('Show FORM T');
    
    const [ButtonShowFormFPCL, setButtonShowFormFPCL]=useState("NEW PROJECT");
    const [ShowFormFPCL, setShowFormFPCL ]=useState(false);
    const handleButtonShowFormFPCL=()=>{
      
      console.log("ShowFormFPCL=" + ShowFormFPCL);

      if(ShowFormFPCL==true){
          //setShowFormFPCL(true); 
          setButtonShowFormFPCL("SHOW DATA SHEET");
          setShowFormFPCL(false)
          setShowForm(true);
          //ShowTableXDataGrid(true)
      }
      else{
          //setShowFormFPCL(false);
          setButtonShowFormFPCL("NEW PROJECT");
          setShowFormFPCL(true)
          setShowForm(false);
          setShowTableXDataGrid(false)

      }
    }

    function changeProjectCategoryName(e){
      
      console.log("eeh=" + e);
      setProjectCategoryName(e ? e: "");
    }

    function handleProjectCategoryNameChange(e){
       //console.log("et=" + e.value);
       console.log("e=" + e.target.value);
       try{
        var ee=e.target.value;
       
       }
       catch(Exception){
        console.log("error=" + Exception);
       }
       console.log("fn=" + ProjectCategoryName);
       console.log("ee=" + ee);
       
       //props.value ? props.value : ""

       //e.target.value ? changeProjectCategoryName(e.target.value) : ""
       
       //console.log("fn1=" + ProjectCategoryName);
       
      }
     
      const [fName, setFName]=useState("f name");

    {/** **/}

    const [PicFile, setPicFile] = useState();
    function handleChangeFile(e) {
        console.log("e.target.files[0]=" + e.target.files[0]);
        setPicFile(URL.createObjectURL(e.target.files[0]));
        console.log("e.target.files=" + e.target.files);
        console.log("e.target.files[0].length=" + e.target.files[0].length);
        console.log("e.target.files[0]=" + e.target.files[0].type);
        console.log("e.target.files[0]=" + e.target.files[0].id);
        console.log("e.target.files[0]=" + e.target.files[0].source);
       
        {
        e.target.files[0].map(function(ev){
          console.log("ev=" + ev);
        })
      }
    }
    
    const handleImageChange = (e)=>{
   
    }
      {/** **/}
  
  const [ProjectCategoryName, setProjectCategoryName] = useState(props?.value ?? '');
  const [PicIntro, setPicIntro]=useState(props?.value ?? '');
  const [WebIntro, setWebIntro]=useState(props?.value ?? '');
  
  function submitProjectCategory(){
    /** 
     'id',
           'service_category',
           'name',
           'pic_intro',
           'intro_txt',
           'status'
     * **/
    //console.log("PicFile=" + PicFile)
    /**/
    const myObj={
           'name': ProjectCategoryName,
           'pic_intro': PicIntro,
           'intro_txt': WebIntro,
           'status': PicFile,
           'service_category': 1,
    }
   console.log("myObj=" + myObj);
   /**/

   //let myFormData=new FormData('upload-file');
   //console.log("formdata=" + myFormData);
   /**
   myFormData.append('name', ProjectCategoryName);
   myFormData.append('pic_intro', PicIntro);
   myFormData.append('intro_txt', PicIntro);
   myFormData.append('service_category', 1);
   myFormData.append('status', PicFile);
   **/
     
    const APIPostOptions={
       method: 'POST',
       headers: { 'Content-Type':'application/json' },
       body: JSON.stringify(myObj)
       //body: myFormData
    }
    
    const APIURL="/myapi/postPrimaryProjectCategory";
        
    try{
        fetch(APIURL, APIPostOptions)
        .then( (response)=> response.json)
        .then( (data)=> console.log("data=" + data))
       // alert("success");
      }
      catch(Exception){
       console.log("Exception=" + Exception)
      }
 }

  const [InputTest, setInputTest]=useState(props?.value ?? '')
    
    return (
      <Box m="20px">
      
      {/** <Button>RECORDS</Button> **/}
      {/**/}

      <Button type="submit" color="secondary" variant="contained"
      onClick={tOPButtonOnClick}
      >
        {topButtonLabelT}
      </Button>
      
      <Button type="submit" color="secondary" variant="contained"
      onClick={handleButtonShowFormFPCL}
      >
        {ButtonShowFormFPCL}
      </Button>
      {/**/}
      <span>
      </span>

      {!showForm && (
      <div style={{height: '1200px'}}>
        <Header title="ADD PROJECT PIC" subtitle="Add Project Pic" />
        <br/>
        <FormProjectAddPic/>
      </div>
      )}
      
      {showForm && (
        <div style={{height: '1200px'}}>
           <Header title="CREATE PROJECT" subtitle="Create a New Project" />
        <br/>
        <FRMNewProjectTest />
      </div>
      )}
      
      
      </Box>
      
    )
  }